const isInteger = (char) => !Number.isNaN(Number.parseInt(char));
export const formatPhoneNumber = (value) => {
    if (!value || typeof value !== "string")
        return "";
    const mask = "(000) 000-0000 ext. 00000";
    let valueIndex = 0;
    let formatted = "";
    let pendingMaskChars = "";
    if (value[0] == "1") {
        formatted = "+1 ";
        value = value.slice(1);
    }
    if (value.slice(0, 2) == "+1") {
        formatted = "+1 ";
        value = value.slice(2);
    }
    for (let i = 0; i < mask.length; i++) {
        let nextChar = "";
        if (valueIndex >= value.length) {
            return formatted;
        }
        if (mask[i] == "0") {
            while (nextChar == "" && valueIndex <= value.length) {
                if (isInteger(value[valueIndex])) {
                    nextChar += pendingMaskChars + value[valueIndex];
                    pendingMaskChars = "";
                }
                valueIndex++;
            }
        }
        else {
            pendingMaskChars += mask[i];
        }
        formatted += nextChar;
    }
    return formatted;
};
//# sourceMappingURL=phone-formatting.js.map